// extracted by mini-css-extract-plugin
export default {"pageWrapper":"NotEnoughGoodsPage_pageWrapper__t-zIj","listWrapper":"NotEnoughGoodsPage_listWrapper__QDw1k"};